import { CellLayout, ChakraFlex, Tag, TagColor, Text } from '@equip.health/ui';

interface InquiryInsuranceCompanyNameCellProps {
  id: string;
  payor: {
    id: string;
    name: string;
    reviewStatus: string;
  };
}

const InquiryInsuranceCompanyNameCell = ({
  id,
  payor,
}: InquiryInsuranceCompanyNameCellProps) => {
  // const [inNetwork, setInNetwork] = useState<boolean>(false);

  return payor ? (
    <CellLayout id={id}>
      <ChakraFlex
        alignItems="center"
        gap="6px"
        overflowX="hidden"
        textOverflow="ellipsis"
      >
        {/* TODO: uncomment later in when inNetwrok tag is present in API call
         {inNetwork ? (
          <Tag
            color={TagColor.green}
            id={`status-cell-in-network__${id}`}
            value="INN"
          />
        ) : (
          <Tag
            color={TagColor.red}
            id={`status-cell-out-of-network__${id}`}
            value="ONN"
          />
        )} */}
        <Text>{payor.name}</Text>
      </ChakraFlex>
    </CellLayout>
  ) : (
    <CellLayout id={id}>
      <Tag color={TagColor.gray} id={id} value="Not set" />
    </CellLayout>
  );
};

export default InquiryInsuranceCompanyNameCell;
